module.exports = __webpack_public_path__ + "static/media/Chrisna.86f840b6.jpg";